module.exports = __webpack_public_path__ + "img/TGT-Melissa-Marshall-27 2.6bbb2b9a.png";